import { useAuthStore } from '../stores/auth';
import { phamViCuaVaiTro } from '../lib/pham-vi-cong';
import type { PhamViCong } from '../lib/pham-vi-cong';

/**
 * Phạm vi cổng của người đang đăng nhập — bản reactive, dùng trong cây React.
 *
 * Đọc qua selector của kho để đổi tài khoản là giao diện đổi ngay, không phải
 * tải lại trang.
 */
export function usePhamVi(): PhamViCong {
  const roles = useAuthStore((s) => s.user?.roles);
  return phamViCuaVaiTro(roles);
}
